import { createSlice } from "@reduxjs/toolkit";
import { saveLeaves } from "services/leaves/leaves";

const initialState = {
    leaves : {
        data: [],
        isLoading: false,
        isSuccess: false,
        errorMessage: ''
    }
}
export const saveLeavesSlice = createSlice({
    name: 'save leaves',
    initialState,
    extraReducers: {
        [saveLeaves.pending]: (state) => {
            state.leaves.isLoading = true;
        },
        [saveLeaves.fulfilled]: (state, { payload }) => {
            state.leaves.isLoading = false;
            state.leaves.isSuccess = true;
            state.leaves.data = payload;
        },
        [saveLeaves.rejected]: (state, { payload }) => {
            state.leaves.isLoading = false;
            state.leaves.isSuccess = false;
            state.leaves.errorMessage = payload
        }
    }
})
export default saveLeavesSlice.reducer;